import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { FlexBox, Stack } from '@ardoq/layout';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';

type NoDateRangeTimeFieldsDoqProps = {
  doqType: DoqType;
  i18nLocale: I18nLocale;
};

const NoDateRangeTimeFieldsDoqBase = ({
  doqType,
  i18nLocale,
}: NoDateRangeTimeFieldsDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noDateRangeTimeFields.title',
          'No date range or time fields'
        )}
        message={
          <Stack gap="xlarge">
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noDateRangeTimeFields.message1',
                "This workspace doesn't have any date range or time fields applied."
              )}
            </FlexBox>
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noDateRangeTimeFields.message2',
                'To use this view, add a date range or time field to your components.'
              )}
            </FlexBox>
          </Stack>
        }
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoDateRangeTimeFieldsDoq = connect(
  NoDateRangeTimeFieldsDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
